export default __webpack_public_path__ + "static/suv-dfsk-1f0c1e6a11893e7c2574765359319a69.png";